import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import CustomerGroupList from "../components/customerGroups/customerGroupsList";
import AddEditCustomerGroups from "../components/customerGroups/addEditCustomerGroups";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const CustomerGroupStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"CustomerGroupList"}
            screenOptions={{ headerShown: false }}>
            <AppStack.Screen name="CustomerGroupList" component={CustomerGroupList} />
            <AppStack.Screen name="AddEditCustomerGroups" component={AddEditCustomerGroups} />
        </AppStack.Navigator>
    );
};

export default CustomerGroupStack;